module.exports = __webpack_public_path__ + "img/7.3fbc7a6c.jpg";